module.exports = __webpack_public_path__ + "img/form-bg.d19f4f1b.png";